"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

type GalleryImageProps = {
  url: string;
  alt: string;
  isVertical?: boolean;
};

export default function GalleryImage({ url, alt, isVertical: isVerticalProp }: GalleryImageProps) {
  const [isVertical, setIsVertical] = useState(isVerticalProp ?? false);

  useEffect(() => {
    // If prop is provided, use it and skip detection
    if (isVerticalProp !== undefined) {
      setIsVertical(isVerticalProp);
      return;
    }

    // Only detect if prop is not provided
    const img = new window.Image();
    img.onload = () => {
      const vertical = img.height > img.width;
      setIsVertical(vertical);
    };
    img.src = url;
  }, [url, isVerticalProp]);

  return (
    <div
      className={`relative overflow-hidden w-full ${
        isVertical ? "gallery-image-vertical" : "gallery-image-landscape"
      }`}
    >
      <Image
        src={url}
        alt={alt}
        fill
        className="object-cover"
        sizes="(min-width:1024px) 353px, (min-width:640px) 50vw, 100vw"
      />
    </div>
  );
}

